/**
 * Страница запроса сброса пароля.
 */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../api/client';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const res = await authAPI.requestReset(email);
      setMessage(res.data.message);
      // В dev-режиме сервер возвращает токен
      if (res.data.reset_token) {
        setResetToken(res.data.reset_token);
      }
    } catch (err: any) {
      setMessage(err.response?.data?.error || 'Ошибка запроса');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Сброс пароля</h1>
        <p style={styles.subtitle}>Введите email для получения инструкций</p>

        <form onSubmit={handleSubmit}>
          {message && (
            <div style={{
              ...styles.message,
              backgroundColor: message.includes('инструкции') ? '#f0fdf4' : '#fef2f2',
              color: message.includes('инструкции') ? '#166534' : '#dc2626',
            }}>
              {message}
            </div>
          )}

          <div style={styles.field}>
            <input
              type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="example@mail.ru" required
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Отправка...' : 'Отправить'}
          </button>
        </form>

        {resetToken && (
          <div style={{ marginTop: 16, padding: 14, backgroundColor: '#fffbeb', borderRadius: 8, fontSize: 13 }}>
            <strong>Dev-режим:</strong>{' '}
            <Link to={`/reset-password?token=${resetToken}`}>
              Перейти к сбросу пароля
            </Link>
          </div>
        )}

        <p style={styles.link}>
          <Link to="/login">Вернуться к входу</Link>
        </p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    minHeight: '100vh', backgroundColor: 'var(--bg-body)',
  },
  card: {
    backgroundColor: 'var(--bg-card)', padding: 40, borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', width: 400, maxWidth: '90vw',
  },
  title: { textAlign: 'center', color: '#2563eb', marginBottom: 4, fontSize: 24 },
  subtitle: { textAlign: 'center', color: 'var(--text-secondary)', marginBottom: 24, fontSize: 14 },
  message: { padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  field: { marginBottom: 16 },
  input: {
    width: '100%', padding: '10px 14px', border: '1px solid var(--border-color)',
    borderRadius: 8, fontSize: 15, boxSizing: 'border-box' as const,
  },
  button: {
    width: '100%', padding: '12px', backgroundColor: '#2563eb', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer',
  },
  link: { textAlign: 'center', marginTop: 16, fontSize: 14, color: 'var(--text-secondary)' },
};

export default ForgotPasswordPage;
